// @vendors
const Immutable = require('immutable');
const { each } = require('lodash');

// @constants
const actionTypes = require('../raConstants/actionTypes');

// @utilities
const {
    setDifferenceAndChartPoints,
} = require('../utilities/RAObjectiveTrackingGetYearAndNoOfPoints');

function _addRangesToChartData(data) {
    each(data, d => {
        d.lowRange = [d.one, d.mid];
        d.highRange = [d.mid, d.ninetyNine];
    });

    return data;
}

const initialState = Immutable.fromJS({
    chartData: [],
    noOfDataPoints: 0,
    gapTerm: 0,
    isFetching: false,
    error: null,
    daysDiff: 0,
    yearDiff: 0,
    noOfChartPoints: 0,
});

const RAProjectionChartOjectiveTracking = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_OBJ_TRACKING_PROJECTION_CHART_REQUEST:
            return state.mergeDeep({
                isFetching: true,
                chartData: [],
                error: null,
            });
        case actionTypes.RA_OBJ_TRACKING_PROJECTION_CHART_SUCCESS:
            const { data } = action.payload;
            return state.mergeDeep({
                isFetching: false,
                error: null,
                chartData: _addRangesToChartData(data),
            });
        case actionTypes.RA_OBJ_TRACKING_PROJECTION_CHART_FAILURE:
            return state.mergeDeep({
                isFetching: false,
                error: action.payload.data,
                chartData: [],
            });
        case actionTypes.RA_OBJ_TRACKING_PROJECTION_CHART_SET_DAYS_DIFF:
            const {
                daysDiff,
                yearDiff,
                noOfChartPoints,
            } = setDifferenceAndChartPoints(action.payload.goalDate);
            return state.merge({
                daysDiff,
                yearDiff,
                noOfChartPoints,
            });
        default:
            return state;
    }
};

module.exports = RAProjectionChartOjectiveTracking;
